import { Injectable } from '@angular/core';
import { CustomValidator } from '../../shared/validation';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  hoechsthaftungssummeHaushaltMin(group): number {
    return CustomValidator.hoechsthaftungssummeHaushaltMin(group);
  }
  hoechsthaftungssummeHaushaltMax(): number {
    return CustomValidator.hoechsthaftungssummeHaushaltMax();
  }
  hoechsthaftungssummeEigenheimMin(group): number {
    return CustomValidator.hoechsthaftungssummeEigenheimMin(group);
  }
  hoechsthaftungssummeEigenheimMax(): number {
    return CustomValidator.hoechsthaftungssummeEigenheimMax();
  }
  hoechsthaftungssummeMinExpert(group): number {
    return CustomValidator.hoechsthaftungssummeMinExpert(group);
  }
  hoechsthaftungssummeMin(group): number {
    return CustomValidator.hoechsthaftungssummeMin(group);
  }
  hoechsthaftungssummeMax(group): number {
    return CustomValidator.hoechsthaftungssummeMax(group);
  }
  validateAlter(value): boolean {
    return CustomValidator.validateAlter(value);
  }
}
